import { CustomizedTypography, VStack } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const QuotationFeeTooltip = () => {
  const { tooltip } = useStyles();
  return (
    <VStack className={tooltip} gap={20}>
      <CustomizedTypography variant="subtitle2">
        1. 결제망 이용료는 안전결제 비용과 결제 시스템 제공업체에 내는
        비용입니다.
      </CustomizedTypography>

      <VStack gap={4}>
        <CustomizedTypography variant="caption" color="textSecondary">
          결제망 이용료 (VAT 별도)
        </CustomizedTypography>
        <table>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                신용/체크카드
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                3.3%
              </CustomizedTypography>
            </td>
          </tr>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                무통장입금
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                1,000원
              </CustomizedTypography>
            </td>
          </tr>
        </table>
      </VStack>

      <CustomizedTypography variant="subtitle2">
        2.결제 관리 수수료는 캐파에서 결제 시스템을 운영하는데 필요한
        비용입니다.
      </CustomizedTypography>

      <VStack gap={4}>
        <CustomizedTypography variant="caption" color="textSecondary">
          결제 관리 수수료 (VAT 별도)
        </CustomizedTypography>
        <table>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                0원 ~ 500,000원
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                5%
              </CustomizedTypography>
            </td>
          </tr>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                500,001원 ~ 2,000,000원
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                3%
              </CustomizedTypography>
            </td>
          </tr>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                2,000,001원 ~ 5,000,000원
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                2%
              </CustomizedTypography>
            </td>
          </tr>
          <tr>
            <td>
              <CustomizedTypography variant="subtitle2">
                5,000,001원 ~
              </CustomizedTypography>
            </td>
            <td>
              <CustomizedTypography variant="subtitle2" fontWeight="bold">
                1%
              </CustomizedTypography>
            </td>
          </tr>
        </table>
      </VStack>
      <CustomizedTypography variant="caption" color="textSecondary">
        ※ 수수료율 부담을 최소화하기 위해 견적 금액이 오를수록 수수료율이
        낮아지는 역누진제입니다.
      </CustomizedTypography>
      <CustomizedTypography variant="caption" color="textSecondary">
        ※ 캐파 거래 수수료는 제조 서비스별로 다를 수 있으며 추후 캐파 운영
        상황에 따라 수시로 바뀔 수 있습니다.
      </CustomizedTypography>
    </VStack>
  );
};

export default QuotationFeeTooltip;

const useStyles = makeStyles({
  tooltip: {
    '& > div': {
      width: '100%'
    },
    '& table, tr': {
      border: `1px solid ${colorSet.gray300}`,
      color: colorSet.gray900,
      backgroundColor: colorSet.gray100
    },
    '& tr': {
      height: 34
    },
    '& td': {
      padding: '8px 12px',
      '&:first-child': {
        width: 183
      },
      '&:nth-child(2)': {
        width: 120,
        backgroundColor: colorSet.gray200
      }
    }
  }
});
